import { Component, ViewEncapsulation } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
    selector: 'card-product, app-card-product',
    templateUrl: './card-product.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CardProductComponent extends CardComponent {}
